import styled from 'styled-components';

export const Video = styled.video.attrs({})`
  width: 100%;
  /* max-width: 1440px; */
  height: 100%;
  /* max-height: 588px; */
`;
